const getHighestPriorityService = (activeServiceData) => {
    // If activeServiceData has 1 or fewer items, return it directly
    if (activeServiceData.length <= 1) {
        return activeServiceData;
    }

    let lowestPriorityService = null;

    const filteredServices = activeServiceData.filter(service => service.HIGHEST_SERVICE_PRIORITY !== null);

    // Ensure there are services to reduce
    if (filteredServices.length > 0) {
        lowestPriorityService = filteredServices.reduce((min, service) =>
            parseInt(service.HIGHEST_SERVICE_PRIORITY, 10) < parseInt(min.HIGHEST_SERVICE_PRIORITY, 10)
                ? service
                : min
        );
    }

    return lowestPriorityService ?? activeServiceData; // if HIGHEST_SERVICE_PRIORITY value is null for all activeServices return activeServiceData array
};

export default getHighestPriorityService;